// This opens the klaviyo full page popup by the button text
document.addEventListener('DOMContentLoaded', function() {
  var buttons = document.querySelectorAll('.ai-ticket-card__cta-aymv3lzntn2nkcvhleaigenblock2d5f202tafftd');
  
  buttons.forEach(function(button) {
    var text = button.innerText.trim();
    
     if (text === 'BUY YOUR GLAMPING SPOT') {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = 'https://downtownbetty.com/collections/boho-dreams-accommodations';
      });
    }
  });
});